
import { useState } from 'react';
import { useCart } from '../../../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

interface ServiceInfoProps {
  id: string;
  title: string;
  price: number;
  category: string;
  image: string;
}

export default function ServiceInfo({ id, title, price, category, image }: ServiceInfoProps) {
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (value >= 1) {
      setQuantity(value);
    }
  };

  const incrementQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  const handleAddToCart = () => {
    addToCart({
      id,
      title,
      price,
      image,
      category,
    }, quantity);
  };

  const handleBuyNow = () => {
    addToCart({
      id,
      title,
      price,
      image,
      category,
    }, quantity);
    navigate('/checkout');
  };

  return (
    <div className="bg-white rounded-lg p-8 shadow-sm">
      <p className="text-sm text-gray-600 mb-2">{category}</p>
      <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>
      <p className="text-3xl font-bold text-gray-900 mb-6">${price.toFixed(2)}</p>
      
      <div className="flex items-center gap-4 mb-6">
        <div className="flex items-center border border-gray-300 rounded-md">
          <button
            onClick={decrementQuantity}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Decrease quantity"
          >
            <i className="ri-subtract-line"></i>
          </button>
          <input
            type="number"
            value={quantity}
            onChange={handleQuantityChange}
            className="w-16 text-center border-x border-gray-300 py-2 text-sm focus:outline-none"
            min="1"
          />
          <button
            onClick={incrementQuantity}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Increase quantity"
          >
            <i className="ri-add-line"></i>
          </button>
        </div>
        
        <button
          onClick={handleAddToCart}
          className="flex-1 bg-gray-900 text-white px-8 py-3 rounded-md hover:bg-gray-800 transition-colors font-medium whitespace-nowrap cursor-pointer"
        >
          Add to cart
        </button>
      </div>

      <button
        onClick={handleBuyNow}
        className="w-full bg-amber-500 text-white px-8 py-3 rounded-md hover:bg-amber-600 transition-colors font-medium whitespace-nowrap mb-4 cursor-pointer"
      >
        Buy Now
      </button>

      <p className="text-sm text-gray-600">Category: <span className="text-gray-900">{category}</span></p>
    </div>
  );
}
